import { COMMUTE_TYPES } from '../interfaces/village';

const MOSCOW_REGION_ID = 1;
const SPB_REGION_ID = 2;
const MOSCOW_AREA_REGION_ID = 4593;
const SPB_AREA_REGION_ID = 4588;

export const getCommuteTypeByRegionId = (regionId?: number): string => {
  switch (regionId) {
    case MOSCOW_REGION_ID:
    case MOSCOW_AREA_REGION_ID:
      return COMMUTE_TYPES.mkad;
    case SPB_REGION_ID:
    case SPB_AREA_REGION_ID:
      return COMMUTE_TYPES.kad;
    default:
      return COMMUTE_TYPES.none;
  }
};
